module.exports = __webpack_public_path__ + "img/icone_studio_usa-1.61585568.png";